export default __webpack_public_path__ + "static/media/mintBg.45182dc7.mp4";